/**
 * UI Components Index
 * Central export point for all reusable UI components
 */

// Core UI components
export { Button } from './button';
export { Card } from './card';
export { Badge } from './badge';
export { Separator } from './separator';
export { Label } from './label';
export {
  Skeleton,
  SkeletonText,
  SkeletonCard,
  SkeletonAvatar,
  SkeletonList,
  SkeletonButton,
} from './skeleton';
export { Avatar, AvatarGroup } from './avatar';

// Job-related components
export { InfoCard } from './info-card';
export { InfoRow } from './info-row';
export { StatusBanner } from './status-banner';
export { EmptyState } from './empty-state';

// Navigation components
export {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from './tabs';

export {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuCheckboxItem,
  DropdownMenuRadioItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuGroup,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuRadioGroup,
  DropdownMenuSubTrigger,
  DropdownMenuSubContent,
} from './dropdown-menu';

export {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from './tooltip';

export {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from './accordion';

// Form components
export { Input } from './input';
export { Textarea } from './textarea';
export { Checkbox } from './checkbox';
export { RadioGroup, RadioItem } from './radio-group';
export { Switch } from './switch';

// Type exports
export type { InputProps } from './input';
export type { TextareaProps } from './textarea';
export type { CheckboxProps } from './checkbox';
export type { RadioGroupProps, RadioItemProps } from './radio-group';
export type { SwitchProps } from './switch';
export type { BadgeProps } from './badge';
export type { LabelProps } from './label';
export type { InfoCardProps } from './info-card';
export type { InfoRowProps } from './info-row';
export type { StatusBannerProps, StatusBannerVariant } from './status-banner';
export type { EmptyStateProps } from './empty-state';
export type { AvatarProps, AvatarGroupProps } from './avatar';
